import { createContext } from "react";
export const PreviewContext = createContext({
  preview: { disabled: false },
  setPreview: (value: any) => {},
});
